module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "约测网课",
      "mask-closable": false
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "testNetworkForm",
    staticClass: "form",
    attrs: {
      "model": _vm.testNetworkParam,
      "rules": _vm.ruleTestNetwork,
      "label-width": 80
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生信息"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.testNetworkParam.uid) + "  - " + _vm._s(_vm.testNetworkParam.mobile) + " - " + _vm._s(_vm.testNetworkParam.nickname))])])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "开始Level",
      "prop": "levelId"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "请选择等级，支持搜索"
    },
    on: {
      "on-change": _vm.changeLevel
    },
    model: {
      value: (_vm.testNetworkParam.levelId),
      callback: function($$v) {
        _vm.$set(_vm.testNetworkParam, "levelId", _vm._n($$v))
      },
      expression: "testNetworkParam.levelId"
    }
  }, _vm._l((_vm.bookMaterialLevelList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.title) + "(版本" + _vm._s(item.materialVersion) + ")")])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 10
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "教室",
      "prop": "schoolId"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.testNetworkParam.schoolId),
      callback: function($$v) {
        _vm.$set(_vm.testNetworkParam, "schoolId", _vm._n($$v))
      },
      expression: "testNetworkParam.schoolId"
    }
  }, _vm._l((_vm.$constant.schoolEnums), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "开始课程",
      "prop": "lessonId"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.testNetworkParam.lessonId),
      callback: function($$v) {
        _vm.$set(_vm.testNetworkParam, "lessonId", _vm._n($$v))
      },
      expression: "testNetworkParam.lessonId"
    }
  }, _vm._l((_vm.bookMaterialLessonsList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师",
      "prop": "tchId"
    }
  }, [_c('TeacherSelect', {
    attrs: {
      "category": [3]
    },
    model: {
      value: (_vm.testNetworkParam.tchId),
      callback: function($$v) {
        _vm.$set(_vm.testNetworkParam, "tchId", $$v)
      },
      expression: "testNetworkParam.tchId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "开始时间",
      "prop": "lsnBeginDayTime"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 6
    }
  }, [_c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('Form-item', [_c('Date-picker', {
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择日期",
      "clearable": false
    },
    on: {
      "on-change": _vm.lsnBeginTimeDateChange
    },
    model: {
      value: (_vm.testNetworkParam.lsnBeginTimeDate),
      callback: function($$v) {
        _vm.$set(_vm.testNetworkParam, "lsnBeginTimeDate", $$v)
      },
      expression: "testNetworkParam.lsnBeginTimeDate"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "5"
    }
  }, [_c('Form-item', [_c('Time-picker', {
    attrs: {
      "clearable": false,
      "value": _vm.timeStr,
      "format": "HH:mm",
      "steps": [1, 30],
      "placeholder": "时间"
    },
    on: {
      "on-change": _vm.onChangeTime
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('Form-item', [_c('Select', {
    model: {
      value: (_vm.testNetworkParam.timeLength),
      callback: function($$v) {
        _vm.$set(_vm.testNetworkParam, "timeLength", _vm._n($$v))
      },
      expression: "testNetworkParam.timeLength"
    }
  }, _vm._l((_vm.timeLengthList), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "5",
      "offset": "1"
    }
  }, [_c('Button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.checkTime
    }
  }, [_vm._v("检查")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingTestNetwork
    },
    on: {
      "click": _vm.insertTestNetwork
    }
  }, [_vm._v("确定")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-640ecbaf","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/modal/UserTestNetworkModal.vue
// module id = 1857
// module chunks = 8